import { mergeStyleSets, useTheme,Spinner, SpinnerSize } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";

interface Props {
  text: string;
  isLoading?: boolean;
}

const StatusHeader: FunctionComponent<Props> = (props: Props) => {
  const { text, isLoading } = props;
  const theme = useTheme();
  const classNames = mergeStyleSets({
    authenticating: [
      theme.fonts.mediumPlus,
      {
        textAlign: "center",
        width: "100%",
      },
    ],
  });

  return (
    <>
      <div className={classNames.authenticating}>{text}</div>
      {isLoading && <Spinner size={SpinnerSize.large} style={{ marginTop: 5 }} />}
    </>
  )
  
};

export default StatusHeader;
